module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.f2b949c5.png";